export default class {
    lat = 0;

    lng = 0;

    mapFromDto(position) {
        if(!position)
            return this;

        this.lat = position.Latitude;
        this.lng = position.Longitude;
        return this;
    }
}